import { DeviceStatusName, SiteType } from '@iot-platform/models/i4b';
import { I4BCellType } from '../configurations';
import { I4bCellConcept } from '../enums';
import { HeaderType } from '../models';
import { I4BButtonColumn } from './i4b-button.column';

export class I4BDeviceButtonColumn extends I4BButtonColumn {
  constructor() {
    super(
      {
        type: HeaderType.CALL_TO_ACTION,
        displayName: 'BUTTON',
        icon: ''
      },
      {
        concept: I4bCellConcept.DEVICES,
        isConfigurable: false,
        isDefault: true,
        isLink: false,
        position: '',
        sortProperty: '',
        width: 10,
        id: 'button',
        cell: {
          type: I4BCellType.CALL_TO_ACTION,
          singleActions: [
            {
              order: 10,
              key: 'moveTo',
              label: 'IOT_DICTIONARY.MOVE_TO',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 11,
              key: 'replace',
              label: 'IOT_DICTIONARY.REPLACE',
              enableConditions: [],
              disableConditions: [
                [{ key: 'status.name', value: DeviceStatusName.decommissioned }],
                [{ key: 'status.name', value: DeviceStatusName.test_mode }],
                [{ key: 'site.type', value: SiteType.STOCK }]
              ],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 20,
              key: 'refresh',
              label: 'DEVICES.CARD.REFRESH',
              enableConditions: [[{ key: 'outgoingConnector.requestConfiguration.commands', value: 'refresh' }]],
              disableConditions: [
                [
                  { key: 'status.name', value: DeviceStatusName.test_mode },
                  { key: 'status.name', value: DeviceStatusName.decommissioned }
                ]
              ],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 30,
              key: 'configure',
              label: 'DEVICES.CARD.CONFIGURE',
              enableConditions: [],
              disableConditions: [
                [
                  { key: 'status.name', value: DeviceStatusName.decommissioned },
                  { key: 'incomingConnector.configuration.url', value: '' },
                  { key: 'incomingConnector.configuration.url', value: null },
                  { key: 'incomingConnector.configuration.url', value: undefined }
                ]
              ],
              visibleConditions: [[{ key: 'canCreateDevice', value: true }]]
            }
          ],
          bulkActions: [
            {
              order: 10,
              key: 'bulkAddTag',
              label: 'GRID_ENGINE.COLUMNS.CTA.ADD_TAGS',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 15,
              key: 'bulkReplaceTag',
              label: 'GRID_ENGINE.COLUMNS.CTA.REPLACE_TAGS',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 20,
              key: 'bulkRemoveTag',
              label: 'GRID_ENGINE.COLUMNS.CTA.REMOVE_TAGS',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            },
            {
              order: 30,
              key: 'bulkRefresh',
              label: 'DEVICES.CARD.REFRESH',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canReadDevice', value: true }]]
            },
            {
              order: 40,
              key: 'bulkMoveTo',
              label: 'IOT_DICTIONARY.MOVE_TO',
              enableConditions: [],
              disableConditions: [[{ key: 'status.name', value: DeviceStatusName.test_mode }]],
              visibleConditions: [[{ key: 'canUpdateDevice', value: true }]]
            }
          ],
          visibleConditions: [
            [
              { key: 'canUpdateDevice', value: true },
              { key: 'canReadDevice', value: true }
            ]
          ],
          enableConditions: []
        }
      },
      { order: 1000 }
    );
  }
}
